import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LabelList,
  Cell,
} from 'recharts';

export const BallotComparisonChart = () => {
  const data = [
    { city: 'San Francisco', measures: 15, color: '#ef4444' },
    { city: 'Oakland', measures: 3, color: '#3b82f6' },
    { city: 'San José', measures: 1, color: '#10b981' },
  ];

  return (
    <div className="my-6">
      <div className="w-full max-w-2xl mx-auto">
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={data}
            margin={{ top: 20, right: 16, left: 0, bottom: 8 }}
            aria-label="Local ballot measures in Nov 2024 for San Francisco, Oakland, and San José"
          >
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis dataKey="city" tickLine={false} axisLine={false} />
            <YAxis allowDecimals={false} tickLine={false} axisLine={false} />
            <Bar dataKey="measures" radius={[6, 6, 0, 0]}>
              {data.map((entry, idx) => (
                <Cell key={`cell-${idx}`} fill={entry.color} />
              ))}
              <LabelList dataKey="measures" position="top" />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
        <p className="text-sm text-gray-600 mt-2 text-center italic">
          Local ballot measures in November 2024
        </p>
      </div>
    </div>
  );
};
